import { defineType } from "sanity";
import { contentFilterPreview } from "../../common/localization";
import { airNonAirFilter, locationFilter } from "../base";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  name: "serviceRow",
  type: "object",
  title: "Service Row",
  fields: [
    {
      name: "tagline",
      title: "Tagline",
      type: "multilingualArrayString"
    },
    {
      name: "title",
      type: "multilingualArrayString",
      validation: (Rule) => Rule.required()
    },
    {
      name: "description",
      type: "multilingualArrayBlockContent",
      validation: (Rule) => Rule.required()
    },
    {
      name: "images",
      title: "Images",
      description: "if more than 1, a slideshow is shown",
      type: "array",
      of: [
        {
          type: "imageWithAlt"
        },
        {
          type: "videoWithPosterImage"
        }
      ]
    },
    {
      type: "ctaButtons",
      name: "ctaButtons",
      title: "CTA Buttons",
      options: {
        collapsible: true,
        collapsed: true
      }
    },
    {
      name: "locationFilters",
      title: "Location Filters",
      type: "array",
      of: [
        {
          type: locationFilter.name
        },
        {
          type: airNonAirFilter.name
        }
      ]
    }
    // {
    //   name: "layout",
    //   type: "string",
    //   validation: (Rule) => Rule.required(),
    //   options: {
    //     list: [
    //       { title: "Image left", value: "left" },
    //       { title: "Image right", value: "right" }
    //     ]
    //   }
    // }
  ],
  preview: {
    select: {
      title: "title",
      images: "images",
      locationFilters: "locationFilters"
    },
    prepare({ title, images, locationFilters }) {
      return {
        title: multilingualStringPreview(title),
        media: images[0],
        subtitle: contentFilterPreview(locationFilters)
      };
    }
  }
});
